import tentants from '../tenants';

export const colors = {
    black: '#000000',
    cabaret: '#cf5464',
    doveGray: '#757575',
    gray: '#a8a8a8',
    gulfStream: '#75B3B2',
    harvestGold: '#eeeeee',
    irisBlue: '#00bcd4',
    lightGray: 'rgba(225,225,225,.2)',
    lochinvar: '#338b86',
    mossGreen: '#acdaae',
    orange: '#ffa500',
    platinateBlue: '#666666',
    redOrange: '#f44336',
    white: '#ffffff',
};

const tenantConfig = (process.env.REACT_APP_TENANT && tentants[process.env.REACT_APP_TENANT]) ?
    tentants[process.env.REACT_APP_TENANT] :
    tentants.mobian;

export default Object.assign({
    fontFamily: '"Lato", Helvetica, Arial, sans-serif',
    fontSize: 15,
    lineHeight: 1.65,
    app: {
        background: '#edecec',
    },
    actions: {
        true: colors.lochinvar,
        false: '#cc0022',
        neutral: colors.doveGray,
    },
    palette: {
        accent1Color: '#ef4769',
        aluminium: '#999999',
        black: colors.black,
        blond: '#fdf3ba',
        chinook: '#a3cea5',
        colonialWhite: '#FFEEBA',
        darkOrange: '#ff8d05',
        deepCarminePink: '#f23a2f',
        desertStorm: '#f8f8f8',
        doveGray: colors.doveGray,
        envy: '#8aab8b',
        gallery: '#efefef',
        gray: colors.gray,
        irisBlue: colors.irisBlue,
        ligthGray: colors.lightGray,
        mossGreen: colors.mossGreen,
        offWhite: '#f9f9f9',
        pickerHeaderColor: colors.lochinvar,
        pipi: '#FFF3CD',
        primary1Color: colors.lochinvar,
        primary2Color: '#005d59', // Dark
        redOrange: colors.redOrange,
        silver: '#c0c0c0',
        springRain: '#99bd9b',
        stack: '#8e8e8e',
        stardust: '#a0a0a0',
        tomato: '#ff574b',
        white: colors.white,
        wildSand: '#f4f4f4',
        yukonGold: '#786600',
    },
    accordion: {
        border: 'rgb(224, 224, 224)',
        closed: colors.white,
        content: colors.white,
        highlight: '#f5f4f4',
        open: '#f5f4f4',
    },
    appBar: {
        color: colors.lochinvar,
    },
    cards: {
        header: colors.harvestGold,
    },
    table: {
        head: {
            color: 'rgba(0, 0, 0, 0.87)',
            border: 'rgb(224, 224, 224)',
            background: colors.white,
            inactive: 'rgba(0, 0, 0, 0.6)',
        },
        body: {
            row: {
                background: 'rgb(224, 224, 224)',
                hover: 'rgba(224, 224, 224, 0.4)',
                color: 'rgba(0, 0, 0, 0.87)',
                border: 'rgb(224, 224, 224)',
            },
        },
    },
    tabs: {
        backgroundColor: colors.white,
        selectedTextColor: colors.irisBlue,
        textColor: colors.doveGray,
    },
    toggle: {
        trackOffColor: colors.doveGray,
    },
    inkBar: {
        backgroundColor: colors.irisBlue,
    },
    textField: {
        floatingLabelColor: colors.platinateBlue,
        disabledTextColor: colors.platinateBlue,
    },
}, tenantConfig.theme);



// WEBPACK FOOTER //
// ./src/theme/theme.js